import React from "react";

import Header from "../header";
import Footer from "../footer";

const Layout = ({ children }) => {
  return (
    <>
      <main className="  ">{children}</main>
      <Footer />
    </>
  );
};

export default Layout;
